import React from "react";
import { Comparator } from "react-bootstrap-table2-filter";
import { withRouter } from "react-router-dom";
import { labels } from "../../../../../localization/labels";
import LifeCycleClassDefinitionService from "../../../../../services/LifeCycleClassDefinitionService";
import PathUtil from "../../../../../utils/PathUtil";
import TableUtils from "../../../../core/Table/TableUtils";
import { paths } from "../../../../paths";
import TableComponent from "../../../page/TableComponent";
import LifeCycleClassDefinition from "./LifeCycleClassDefinition";

class LifeCycleClassDefinitionContainer extends TableComponent {
  constructor(props) {
    super(props);

    this.props = props;
    this.lifeCycleClassDefinitionService = new LifeCycleClassDefinitionService();
  }

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      headerClasses: "column-header-id",
      classes: "column-id",
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.id, Comparator.EQ)
    },
    {
      dataField: "name",
      text: labels.name,
      headerClasses: "column-header-filtered",
      sort: true,
      formatter: TableUtils.textFormatter,
      headerFormatter: this.formatHeader,
      filter: TableUtils.textFilter(labels.name)
    }
  ]);

  getComponentTitle = () => {
    return labels.lifeCycleClassDefinitions;
  };

  loadData = pageInfo => {
    this.prepareCall(
      this.lifeCycleClassDefinitionService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRowClick = (_, row) => {
    const itemPath = PathUtil.adminItemsPath(
      { path: paths.LIFE_CYCLE },
      { path: paths.CLASS_DEFINITION, id: row.id }
    );
    this.changePath(itemPath, row.name);
  };

  render() {
    return (
      <LifeCycleClassDefinition
        {...this.renderProps()}
        onRowClick={this.onRowClick}
      />
    );
  }
}

export default withRouter(LifeCycleClassDefinitionContainer);
